export const PAGINATION = {
  pageSize: 10,
  pageSizes: [10, 20, 30, 40, 50]
};
